module.exports = __webpack_public_path__ + "img/1021.acdcb49a.png";